import Datetime from 'utils/datetime/datetime'
import { getDayHourStarts, getDayTimeStepLabels, getHourStepLabel, HOUR_MINUTES } from 'utils/datetime/dayTimeSteps'

export function getBidTimestamp(baseStartTime: Date, hourIndex: number): ISODateTime {
  return Datetime.addHours(Datetime.toISOString(baseStartTime), hourIndex)
}

export function getBidHourRangeLabel(baseStartTime: Date, hourIndex: number): string {
  return getHourStepLabel(getBidTimestamp(baseStartTime, hourIndex))
}

export function getBidHourRangeLabels(baseStartTime: Date, rowCount: number): string[] {
  const labelsByDay = new Map<ISODateTime, string[]>()

  return Array.from({ length: rowCount }, (_, hourIndex) => {
    const timestamp = getBidTimestamp(baseStartTime, hourIndex)
    const dayStart = Datetime.getStartOfDay(timestamp)
    let dayLabels = labelsByDay.get(dayStart)
    if (!dayLabels) {
      dayLabels = getDayTimeStepLabels(getDayHourStarts(timestamp), HOUR_MINUTES)
      labelsByDay.set(dayStart, dayLabels)
    }

    const dayHourIndex = Math.floor(Datetime.getNrOfMinutesBetween(dayStart, timestamp) / HOUR_MINUTES)
    return dayLabels[dayHourIndex]
  })
}

export function getBidRowDateLabel(baseStartTime: Date, hourIndex: number): string {
  return Datetime.toLocalTime(getBidTimestamp(baseStartTime, hourIndex), 'onlyDate')
}
